import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { isIOS } from 'react-device-detect';
import styled, { createGlobalStyle, css } from 'styled-components';
import { useNonScalableViewport } from '../../hooks/useNonScalableViewport';
import { resetScroll } from './View';
export function MobileView({ children, onTouchEnd: onTouchEndProp, innerRef, ...props }) {
    useEffect(resetScroll, []);
    useNonScalableViewport();
    return (_jsxs(_Fragment, { children: [_jsx(GlobalStyle, {}), _jsx(MobileViewRoot, { ...props, ref: innerRef, onTouchEnd: (e) => {
                    onTouchEndProp?.(e);
                    resetScroll();
                }, "$useFullscreenHack": isIOS, children: _jsx(MobileViewContent, { children: children }) })] }));
}
const MobileViewContent = styled.div `
    position: fixed;
    top: 0;
    left: 0;
    width: 100dvw;
    height: 100dvh;
    z-index: 1000;
`;
const MobileViewRoot = styled.div `
    --BlockedPermissions_BorderRadius: 0;
    --Stage_PaddingTop: 0rem;
    --Stage_PaddingBottom: 0rem;
    --Stage_PaddingLeft: 0rem;
    --Stage_PaddingRight: 0rem;
    --Stage_Height: 100dvh;
    --Stage_Width: 100dvw;

    position: relative;
    z-index: 1;
    width: 100dvw;
    height: 100dvh;

    ${({ $useFullscreenHack }) => $useFullscreenHack &&
    css `
            width: 10000px;
            height: 10000px;
        `}
`;
const GlobalStyle = createGlobalStyle `
    :root {
        --Layout_Background: #000000;
        --BlockedPermissions_Background: none;
    }

    html,
    body {
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* IE and Edge */
    }

    /* WebKit browsers (Safari, Chrome on iOS) */
    html::-webkit-scrollbar,
    body::-webkit-scrollbar {
        display: none;
        width: 0;
        height: 0;
    }
`;
